import { Typography } from '@mui/material';
import _ from 'lodash';
import { Fragment, useEffect, useState } from 'react';
import {
  ResourceType,
  useInstitutionalResources,
} from '../../hooks/useInstitutionalResources';
import VegaSearchBy from '../common/VegaSearchBy';
import VegaTable from '../common/VegaTable';
import { VegaCard } from '../common';

function CurrencyCodeTable() {
  const { loading, fetchResource } = useInstitutionalResources();
  const [countryCodes, setCountryCodes] = useState<any[]>([]);
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowCount, setRowCount] = useState<number>(0);
  const [filter, setFilter] = useState<{ search: string; searchBy: string }>({
    search: '',
    searchBy: CURRENCY_COLUMNS[0].value,
  });

  async function fetchCurrencyCodes() {
    try {
      const response = await fetchResource<any>({
        type: ResourceType.CURRENCY_CODE,
        page: page,
        pageSize: pageSize,
        searchBy: filter.searchBy,
        searchQuery: filter.search,
      });
      setCountryCodes(response.records);
      setRowCount(response.totalItems);
    } catch (error) {}
  }

  const onFilterChange = (name: string, value: string) => {
    if (name === 'searchBy') {
      setFilter((preVal: any) => ({
        ...preVal,
        ['search']: '',
        ['searchBy']: value,
      }));
    } else {
      setFilter((preVal: any) => ({
        ...preVal,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    fetchCurrencyCodes();
  }, [page, pageSize, filter.search, filter.searchBy]);

  return (
    <Fragment>
      <VegaSearchBy
        placeholder="Search"
        data={CURRENCY_COLUMNS}
        searchByname="searchBy"
        searchName="search"
        key="search"
        state={filter}
        handleChange={onFilterChange}
      />
      <VegaCard noPad>
        <VegaTable
          data={countryCodes}
          columnDef={columnCurrencyCode}
          idColumn={'id'}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
          page={page}
          pageSize={pageSize}
          rowCount={rowCount}
          paginationMode="server"
          loading={loading}
        />
      </VegaCard>
    </Fragment>
  );
}
export default CurrencyCodeTable;

const CURRENCY_COLUMNS = [
  {
    text: 'Currency Name',
    value: 'currencyName',
  },
  {
    text: 'Country Name',
    value: 'country',
  },
  {
    text: 'ISO Code',
    value: 'isoCode',
  },
];

const columnCurrencyCode = [
  {
    field: 'currencyName',
    headerName: '  Currency Name',
    renderCell: (props: any) => {
      return <Typography>{_.capitalize(props.row.currencyName)}</Typography>;
    },
    flex: 1,
  },
  {
    field: 'country',
    headerName: '  Country Name',
    renderCell: (props: any) => {
      return <Typography>{_.capitalize(props.row.country)}</Typography>;
    },
    flex: 1,
  },
  {
    field: 'isoCode',
    headerName: '  ISO Code',
    renderCell: (props: any) => {
      return <Typography>{props.row.isoCode?.toUpperCase()}</Typography>;
    },
    flex: 1,
  },
];
